<template lang="pug">
  div.filter(@click="toggle")
    i.icon.iconfont.icon-menu
    span 筛选
</template>
<script>
export default {
  name: 'FilterBy',
  props: {
    toggle: {
      type: Function

    }
  }
}
</script>
<style lang = "scss" scoped>
.filter {
  border: 1px solid #e7e7ef;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  color: #74747b;
  text-transform: uppercase;
  padding: 0.6rem;
  .icon {
    margin-right: 0.5em;
  }
}

</style>
